<template>
  <div class="header" :style="{ background: bgColor || 'transparent' }">
    <div @click="handleBack" class="huisuiyunfont">{{'\ue670'}}</div>
    <div class="title">{{headerTitle}}</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    handleBack () {
      if (this.url) {
        this.$router.push(this.url)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="less">
.header{
  font-family: 'Alibaba PuHuiTi';
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
  font-weight: 500;
  color: #fff;
  height: 100px;
  padding: 0px 24px;
  box-sizing: border-box;
}
.header>div:first-of-type{
  font-size: 42px;
}
.title{
  margin-left: -26px;
  font-size: 30px !important;
}
</style>
